import { render, staticRenderFns } from "./VanTruckSale.vue?vue&type=template&id=62f0c654"
import script from "./VanTruckSale.vue?vue&type=script&lang=js"
export * from "./VanTruckSale.vue?vue&type=script&lang=js"
import style0 from "./VanTruckSale.vue?vue&type=style&index=0&id=62f0c654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports